module.exports = __webpack_public_path__ + "img/Jcorazon.fdf4ffc4.png";